import React from 'react';
import Check from '../../../assets/icons/Check';
import './StepperBubble.scss';


const StepperBubble = ({name, number, checked, withBar, active}) => {
    return (
        <div className={'v2-stepper-bubble-container'}>
            <div className={'flex-aligned-justified-center v2-bubble-bar-container'}>
                <div
                    className={`flex-aligned-justified-center v2-stepper-bubble-circle ${checked || active ? 'v2-bg-primary-500' : 'v2-bg-text-disabled'}`}>
                    {checked ? <Check width={'14'} height={'10'} color={'white'}/> :
                        <p className={'subtitle-1 color-white'}>{number}</p>}
                </div>
                {withBar && <div className={'v2-stepper-line'}></div>}
            </div>
            <p className={'v2-bubble-name subtitle-2'}>{name}</p>
        </div>
    );
};
export default StepperBubble;
